import React from "react";

import afriMoneyLogo from "../../assets/Mafrimoyen.png";
import airtelMoneyLogo from "../../assets/Mairtelmoney.png";
import orangeMoneyLogo from "../../assets/MorangeMoney.png";
import mpesaLogo from "../../assets/Mpesa.png";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const mobileMoneyNetworks = [
  { name: "AfriMoney", logo: afriMoneyLogo },
  { name: "Airtel Money", logo: airtelMoneyLogo },
  { name: "Orange Money", logo: orangeMoneyLogo },
  { name: "M-Pesa", logo: mpesaLogo },
];

const MobileMoneyNetworks = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-mobile-networks"
      aria-labelledby="ws-mobile-networks-title"
    >
      <div className="ws-shell ws-mobile-networks__layout">
        <RevealOnScroll className="ws-mobile-networks__heading">
          <span className="ws-kicker">{t("Intégrations Mobile Money")}</span>
          <h2 id="ws-mobile-networks-title">
            {t("Les principaux réseaux, réunis dans une seule intégration")}
          </h2>
          <p>
            {t(
              "WonyaPay connecte vos parcours d’encaissement et de paiement aux réseaux Mobile Money disponibles en RDC.",
            )}
          </p>
        </RevealOnScroll>

        <ul
          className="ws-mobile-networks__grid"
          aria-label={t("Réseaux Mobile Money intégrés à WonyaPay")}
        >
          {mobileMoneyNetworks.map((network, index) => (
            <RevealOnScroll
              as="li"
              className="ws-mobile-networks__item"
              delay={index * 70}
              key={network.name}
              variant="fade-left"
            >
              <figure>
                <img
                  src={network.logo}
                  alt=""
                  aria-hidden="true"
                  decoding="async"
                  loading="lazy"
                  width="447"
                  height="447"
                />
                <figcaption>{network.name}</figcaption>
              </figure>
            </RevealOnScroll>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default MobileMoneyNetworks;
